import { useState, useEffect } from 'react';
import { getApiUrl } from '@/lib/api';
import type { FounderProfile } from '@/lib/investorScoring';

interface UseUserProfileResult {
  profile: FounderProfile | null;
  isLoading: boolean;
}

export function useUserProfile(token: string | null): UseUserProfileResult {
  const [profile, setProfile] = useState<FounderProfile | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!token) {
      setIsLoading(false);
      return;
    }

    fetch(`${getApiUrl()}/api/user/profile`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(r => {
        if (!r.ok) return null;
        return r.json();
      })
      .then(data => {
        if (!data) { setProfile({}); return; }
        let industries: string[] = [];
        if (data.industries) {
          try { industries = JSON.parse(data.industries); } catch { industries = []; }
        }
        setProfile({
          stage: data.stage ?? undefined,
          industries,
          funding_amount: data.funding_amount ?? undefined,
          location: data.location ?? undefined,
          business_description: data.business_description ?? undefined,
        });
      })
      .catch(() => setProfile({}))
      .finally(() => setIsLoading(false));
  }, [token]);

  return { profile, isLoading };
}
